import type { ComponentPropsWithoutRef } from "react";
import presidenceLogoUrl from "../../assets/bj/presidence.png";
import presidenceWhiteLogoUrl from "../../assets/bj/presidence-white.png";

type PresidenceLogoProps = ComponentPropsWithoutRef<"img"> & { mask?: boolean; white?: boolean };

export function PresidenceLogo({ className, mask = false, white = false, alt = "", ...props }: PresidenceLogoProps) {
  const logoUrl = white ? presidenceWhiteLogoUrl : presidenceLogoUrl;

  if (!mask) return <img src={logoUrl} alt={alt} className={className} {...props} />;

  return (
    <span
      className={`inline-block size-8 ${className}`}
      {...props}
      style={{
        maskImage: `url(${logoUrl})`,
        WebkitMaskImage: `url(${logoUrl})`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskSize: "contain",
        WebkitMaskSize: "contain",
        maskPosition: "center",
        WebkitMaskPosition: "center",
      }}
    />
  );
}
